import { useContext } from 'react';
import { CommonDataContext } from '../contexts/commonDataContext';

export const useCommonDataContext = () => useContext(CommonDataContext);
